mutation DeleteMoneyPage($input: UrlDeleteInput!) {
    maUrlDelete(input: $input) {
        url {
            name
            url {
                fullyQualifiedUrl
            }
        }
    }
}
